define('wacountdown', ['jquery', 'wamessages'], function ($, wamessages) {

  var wacountdown = {

    countdown: $('.countdown'),
    countdownElement: $('.countdown__container'),
    countdownStartDate: $('.countdown__container').data('start'),
    countdownEndDate: $('.countdown__container').data('end'),
    countdownElementDays: $('.countdown__time--days span'),
    countdownElementHours: $('.countdown__time--hours span'),
    countdownElementMinutes: $('.countdown__time--minutes span'),
    countdownElementSeconds: $('.countdown__time--seconds span'),
    countdownHeadlineStart: $('.countdown__headline.js_toStart'),
    countdownHeadlineEnd: $('.countdown__headline.js_toEnd'),
    countdownAnchor: $('.countdown').closest('a'),
    countdownAnchorHref: $('.countdown').closest('a').attr('href'),
    initialized: 0,

    buildTime: function buildTime() {
      if (this.countdownElement.length == 0) return;
      this.currentStartDate = new Date(this.countdownStartDate.replace(/-/g, "/"));
      this.currentEndDate = new Date(this.countdownEndDate.replace(/-/g, "/"));
      this.buildcountdownToStart();
    },
    buildcountdownToStart: function buildcountdownToStart() {
      var _this = this;

      this.currentStartDate.setDate(this.currentStartDate.getDate());
      this.checkStartcountdown = Date.parse(this.currentStartDate) - Date.parse(new Date());

      if (this.checkStartcountdown < 0) {
        this.buildcountdownToEnd();
        return;
      }
      this.countdownAnchor.attr('href', 'javascript' + String.fromCharCode(58) + 'void(0);');
      this.countdownHeadlineStart.show();
      var countdownToStart = setInterval(function () {
        _this.intervalFunctionality(_this.currentStartDate, countdownToStart, 1);
      }, 1000);
    },
    buildcountdownToEnd: function buildcountdownToEnd() {
      var _this2 = this;

      this.countdownAnchor.attr('href', this.countdownAnchorHref);
      this.countdownHeadlineStart.hide() && this.countdownHeadlineEnd.show();
      var countdownToEnd = setInterval(function () {
        _this2.intervalFunctionality(_this2.currentEndDate, countdownToEnd, 0);
      }, 1000);
    },
    intervalFunctionality: function intervalFunctionality(endtime, countdown, startcountdown) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor(t / 1000 % 60);
      var minutes = Math.floor(t / 1000 / 60 % 60);
      var hours = Math.floor(t / (1000 * 60 * 60) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));

      this.setDatecountdown(days, hours, minutes, seconds);

      if (this.initialized == 0) {
        this.countdown.fadeIn();
        this.initialized = 1;
      }
      if (t <= 0) {
        clearInterval(countdown);
        if (startcountdown == 1) this.buildcountdownToEnd();
      }
    },
    setRedColor: function setRedColor(element) {
      element.addClass('red');
    },
    setDatecountdown: function setDatecountdown(days, hours, minutes, seconds) {
      this.countdownElementDays.html(days);
      this.countdownElementHours.html(hours);
      this.countdownElementMinutes.html(minutes);
      this.countdownElementSeconds.html(seconds);

      if (days == 0) this.setRedColor(this.countdownElementDays);
      if (hours == 0) this.setRedColor(this.countdownElementHours);
      if (minutes == 0) this.setRedColor(this.countdownElementMinutes);
    },
    init: function init() {
      this.buildTime();
    }
  };

  return wacountdown;
});

